module.exports = __webpack_public_path__ + "img/FeedingProducts.e5b88e18.png";